import config from '@/config';

// A resized WebP of an image from our bucket: `preview` (600px wide) for task cards, `avatar` (64px) for avatars.
// The presets are defined in deploy/helm/templates/imgproxy-deployment.yaml. Without imgproxy (local) the original is used.
export function imgproxyUrl(url, preset) {
  const base = config.getImgProxyUrl();
  if (!base) {
    return url;
  }
  const source = btoa(url).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  // the extension also keeps the service worker from answering with index.html (it does so for paths without a dot)
  return `${base}/insecure/${preset}/${source}.webp`;
}
